import openCartMiddleware from '#shared/middleware/openCartMiddleware.js';
import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultTemplate from '#themes/default/default/pages/shoppingCart/shoppingCart.html' with { type: 'html' };

import defaultShoppingCart from '#themes/default/default/pages/shoppingCart/shoppingCart.js';

import cButton from '#themes/default/web/components/button/button.js';
import cButtons from '#themes/default/web/components/buttons/buttons.js';
import cInfoBox from '#themes/default/web/components/infoBox/infoBox.js';
import cLegalAgreementCheckbox from '#themes/default/web/components/legalAgreementCheckbox/legalAgreementCheckbox.js';
import cPaymentSelection from '#themes/default/web/components/paymentSelection/paymentSelection.js';

import headlineTemplate from './html/headline.html' with { type: 'html' };

const template = modifyTemplate(defaultTemplate, [{
	query: '.headline',
	position: 'replace',
	content: headlineTemplate
}]);

export default {
	middleware: [
		openCartMiddleware
	],
	components: {
		cButton,
		cButtons,
		cInfoBox,
		cLegalAgreementCheckbox,
		cPaymentSelection
	},
	extends: defaultShoppingCart,
	computed: {
		getPreselectionHeadline() {
			return this.order.hasTrialProduct && this.isNewCart ? this.t('shoppingCart_headlinePreselection') : '';
		}
	},
	template
};
